module.exports = __webpack_public_path__ + "img/offeo-9.9f5a6f7b.png";